@if (chartOptions) {
  <highcharts-chart
    [Highcharts]="Highcharts"
    [constructorType]="'stockChart'"
    [options]="chartOptions"
    [(update)]="isChartUpdated"
    (wheel)="scroll($event)"
    [runOutsideAngular]="true">
  </highcharts-chart>
}
